import { Component, computed, inject, LOCALE_ID } from '@angular/core';

@Component({
  selector: 'app-coming-soon-page',
  imports: [],
  templateUrl: './coming-soon-page.html',
  styleUrl: './coming-soon-page.scss',
})
export class ComingSoonPage {
  private locale = inject(LOCALE_ID);
  isArabic = computed(() => this.locale.startsWith('ar'));
}
